import {defineStore} from 'pinia';
import {ModuleSupplierInvoiceBot} from '../moduleConst';
import {BaseDictionaryStore} from '../baseDictionaryStore';
import supplierInvoiceApi from '@/apis/supplierinvoice/supplierInvoiceApi.js'

const supplierInvoiceBotStore = new BaseDictionaryStore(supplierInvoiceApi);

export const useSupplierInvoiceBotStore = defineStore(ModuleSupplierInvoiceBot, {
  state: () => ({
    ...supplierInvoiceBotStore.state,
    _config: {
      key: 'supplier_id',
      code: 'supplier_code',
      table: 'inbot_invoice_supplier',
      moduleName: 'Bảng nhà cung cấp hóa đơn',
    },
    moduleName: 'supplierInvoiceBot',
  }),
  actions: {...supplierInvoiceBotStore.action},
  getters: {...supplierInvoiceBotStore.getters},
});
